import { RootState } from '@/core/store/store'
import { createSelector } from '@reduxjs/toolkit'

const isAuth = (state: RootState) => state.authReducer
export const authSelector = createSelector(
  isAuth,
  authReducer => authReducer.isAuth,
)

const user = (state: RootState) => state.authReducer
export const userSelector = createSelector(
  user,
  authReducer => authReducer.user,
)
